/**
 * /help — User-facing help report form (authed: 4 roles).
 *
 * Layout: centered, max-width 640px.
 * Server-side: requireSession; client-side: HelpReportForm.
 */

import type { JSX } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { HelpReportForm } from '../../components/help/HelpReportForm.js';

export const Route = createFileRoute('/help/')({
  component: HelpPage,
});

function HelpPage(): JSX.Element {
  return (
    <div className="help-page" data-testid="help-page">
      <div className="help-page-inner">
        <header className="help-page-header">
          <h1 className="help-page-title">Lapor Masalah atau Beri Masukan</h1>
          <p className="help-page-subtitle">
            Ceritakan apa yang Anda alami atau apa yang ingin Anda sampaikan.
            Tim kami akan menindaklanjuti.
          </p>
        </header>
        <HelpReportForm />
      </div>
    </div>
  );
}
